import React, { useCallback, useEffect, useState } from 'react';
import { AfterPayBanner, AlertsList, EmptyProductsFallback, HeroBanner } from '../../components';
import { BREADCRUMB, HEROBANNER, PAGETITLE, PAYPALBANNER, PRODUCTTILES, PROMOMSG } from '../../constants/rootElements';
import { useFeeAlertInjectionScript, useGoogleAnalyticsHandler } from "../../hooks";
import { appendTermsAndConditionsLink } from '../../util/appendTermsAndConditionsLink';
import { Breadcrumb } from '../breadcrumb';
import { TitleBar } from "../productBrowseTitle";
import { NO_JACKET_HERO_BANNER_MSG, SOFTSHELL_JACKET_BANNER_TITLE } from './constants';
import { useDataProcessor } from './hooks';
import { JktProductTiles } from "./jktProductTiles";

export const HSJacketsPage = props => {
    const appData = useDataProcessor(props.appData)
    const [pbData, setPbData] = useState({})
    const [breadcrumbData, setBreadcrupmData] = useState([])
    const [promoMessages, setPromoMessages] = useState([]);
    const [feeAlertRequestData, setFeeAlertRequestData] = useState(null);
    const [googleAnalyticsRequestData, setGoogleAnalyticsRequestData] = useState(null);
    const [currencyCode, setCurrencyCode] = useState(null);

    useFeeAlertInjectionScript(feeAlertRequestData)
    const { selectItemTrackingGASY25, viewModalTrackingGASY25, addToCartTrackingGASY25 } = useGoogleAnalyticsHandler(googleAnalyticsRequestData);

    const JacketsTitleBar = appData?.pagecontentData?.find(data => data.contentType === "ProductBrowseTitle")
    const JacketsBreadcrumb = Boolean(appData?.pagecontentData?.find(data => data.contentType === "Navigation"))
    const JacketsHeroBanner = appData?.pagecontentData?.find(data => data.contentType === "DynamicHeroBanner")
    const ProductBrowseProducts = appData?.pagecontentData?.find(data => data.contentType === "ProductBrowseProducts")
    const PaypalBannerData = appData?.pagecontentData?.find(data => data.contentType === "PaypalId")
    const PaymentOptions = appData?.pagecontentData?.find(data => data.contentType ===  "PaymentOptionsDetail");
    
    const ProductBrowsePromoMsg = Boolean(
		appData?.pagecontentData?.find(
			(data) => data.contentType === 'ProductBrowsePromoMsg'
		)
	);

    const getBreadcrumb = useCallback(() => {
        BREADCRUMB.render(<Breadcrumb pbData={breadcrumbData} />);
    }, [breadcrumbData])
    
    const getHeroBanner = useCallback(() => {
        const heading = pbData.hasSoftshelJacket ? SOFTSHELL_JACKET_BANNER_TITLE : JacketsHeroBanner.heading
        const subHeading = pbData.hasLetterJacket ? JacketsHeroBanner.subheading : NO_JACKET_HERO_BANNER_MSG

        HEROBANNER.render(<HeroBanner 
            heading = {heading}
            subHeading = {subHeading}
            imgURL={JacketsHeroBanner.imageUrl}
            imgAltText={JacketsHeroBanner.imgAltText}
        />);
    }, [JacketsHeroBanner, pbData.hasLetterJacket, pbData.hasSoftshelJacket])

    const productTiles = useCallback(() => {
        PRODUCTTILES.render(
            !!pbData?.products?.length
                ? <JktProductTiles
                    pbData={pbData}
                    pageContent={ProductBrowseProducts}
                    paymentOptions={PaymentOptions}
                    googleAnalytics={{ 
                        selectItemTrackingGASY25, 
                        viewModalTrackingGASY25, 
                        addToCartTrackingGASY25,
                        catalogOSR: googleAnalyticsRequestData?.catalogOsr
                    }}
                />
                : <EmptyProductsFallback
                    productBrowseData={pbData}
                />
        )
        // eslint-disable-next-line
    }, [pbData, PaymentOptions, selectItemTrackingGASY25])

    const paypalBanner = useCallback(() => {
        PAYPALBANNER.render(<AfterPayBanner currencyCode={currencyCode} />);
    },[PaypalBannerData, currencyCode])

	const getPromoMsg = useCallback(() => {
        const messagesWithLink = appendTermsAndConditionsLink(promoMessages);
		PROMOMSG.render(<AlertsList messages={messagesWithLink} />);
	}, [promoMessages]);

    const getTitleBar = useCallback(() => {
        PAGETITLE.render(<TitleBar pageContent={JacketsTitleBar} affiliationData={appData?.affiliationData}/>);
      },[])

    useEffect(() => {
        Object.keys(appData.productBrowseData).map((key) => {
            if (key !== "metaData") {
                const catalog = appData.productBrowseData[key];
                catalog?.productGroups && Object.keys(catalog.productGroups).map((catObj) => {
                    const productGroup = catalog.productGroups[catObj];
                    setPbData(productGroup);
                    setPromoMessages(productGroup.promoMessagesV2);
                    const _currencyCode = productGroup?.products?.[0]?.currencyCode;
                    _currencyCode && setCurrencyCode(_currencyCode);
                    const customerNumber = appData.productBrowseData.metaData.customerNumber;
                    setFeeAlertRequestData({
                        containerSelector: '#promoMsg',
                        customerId: customerNumber,
                        catalogOsr: catalog.catalogOsr,
                    });
                    setGoogleAnalyticsRequestData({
                        customerNumber,
                        publishedCatalogId: catalog.publishedCatalogId,
                        sourceCatalogType: catalog.sourceCatalogType,
                        catalogOsr: catalog.catalogOsr
                    });
                    setBreadcrupmData(productGroup);
                    return true;
                })
            }
            return true
        })
    }, [appData.productBrowseData])

    return (
        <>
            {
                JacketsTitleBar && Object.keys(JacketsTitleBar)?.length > 0 && getTitleBar()
            }
            {
                ProductBrowsePromoMsg && promoMessages?.length > 0 && getPromoMsg()
            }
            {
                JacketsBreadcrumb && getBreadcrumb()
            }
            {
                JacketsHeroBanner && getHeroBanner()
            }
            {
                ProductBrowseProducts && Object.keys(ProductBrowseProducts)?.length > 0 && productTiles()
            }
            {
                PaypalBannerData && Object.keys(PaypalBannerData)?.length > 0 && paypalBanner()
            }

        </>
    )
}
